import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LinkedDocument } from '../../../shared/models/linked-documents';

@Component({
  selector: 'app-related-document-details',
  templateUrl: './related-document-details.component.html',
  styleUrls: ['./related-document-details.component.scss']
})
export class RelatedDocumentDetailsComponent implements OnInit {
  @Input() relatedDocuments?: LinkedDocument[] = [];
  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  loadDocumentDetails = (documentNumber:string,version: number) => {
    // If version is not provided, default to 0 - in release doc Scenario's
    var actualVersion = version ?? 0;
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        '/eqms.documentDetails/' + documentNumber + ':' + actualVersion,
      ])
    );
    window.open(url, '_blank');
  };
  trackByDocumentNumber = (index: number, document: LinkedDocument) => {
    return document.number;
  }
}
